import CheckboxSelectItem from 'components/checkbox-select-item';
import FilterSidebar from 'components/filter-sidebar';
import Select from 'components/select';
import TextField from 'components/text-field';
import { Search } from 'lucide-react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import titleCase from 'utils/title-case';
import SelectSite from 'views/bluviu-nutrition/components/select-site';
import { useSelectedSite } from 'views/bluviu-nutrition/hooks/use-selected-site';
import { BluViuNutritionParams } from 'views/bluviu-nutrition/types/bluviu-nutrition-params.type';
import { CalibrationState } from '../types/calibration-state.enum';
import CreateCalibrationDialog from './create-calibration-dialog';

type Props = {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
};

const FilterListCalibrations: React.FC<Props> = ({
  searchValue,
  setSearchValue,
  selectedFilters,
  setSelectedFilters,
}) => {
  const { selectedSiteId } = useSelectedSite();
  const history = useHistory();

  const params = useParams<BluViuNutritionParams>();

  return (
    <FilterSidebar
      sx={{
        justifyContent: 'flex-end',
      }}
      showClearFilter={!!selectedSiteId || !!searchValue || !!selectedFilters.length}
      clearFilters={() => {
        setSearchValue('');
        setSelectedFilters([]);
        history.push(`/bluviu-nutrition/${params.tab}`);
      }}>
      <SelectSite />
      <Select
        multiple
        label={'State'}
        value={selectedFilters}
        onChange={(event) => {
          setSelectedFilters(event.target.value as string[]);
        }}>
        {Object.entries(CalibrationState)?.map((filter) => (
          <CheckboxSelectItem key={filter[1]} checked={selectedFilters.includes(filter[1])} value={filter[1]}>
            {titleCase(filter[1])}
          </CheckboxSelectItem>
        ))}
      </Select>
      <TextField
        label={'Search'}
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        endAdornment={<Search />}
      />
      <CreateCalibrationDialog />
    </FilterSidebar>
  );
};

export default FilterListCalibrations;
